import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxContext as Context } from './CheckboxGroup.context';
import * as React from 'react';
export const CheckboxGroupControlled = ({ onChange, onValueChange, name, disabled, value, children, }) => {
    const handleChange = React.useCallback((event) => {
        if (onChange)
            onChange(event);
        if (onValueChange) {
            const { value: newValue } = event.target;
            const newValueArray = Array.isArray(value) ? [...value] : [];
            const valueIndex = newValueArray.indexOf(newValue);
            if (valueIndex === -1) {
                newValueArray.push(newValue);
            }
            else {
                newValueArray.splice(valueIndex, 1);
            }
            onValueChange(newValueArray);
        }
    }, [onChange, onValueChange, value]);
    const contextValue = React.useMemo(() => ({ onChange: handleChange, onValueChange: handleChange, disabled, value, name }), [disabled, value, name, handleChange]);
    return _jsx(Context.Provider, { value: contextValue, children: children });
};
